import React from 'react'
import './DetailsThingComp.css';
import {Grid} from '@mui/material';
import { FaFilter } from 'react-icons/fa';

const DetailsThingComp = () => {
  return (
    <div className='DetailsThingCompMain'> 
      <hr style={{marginTop:'7vh',borderColor:'#f2f2f2'}} />
    <p className='DetailsThingsHeading'>Thinks to know</p>
    <Grid container>
        <Grid item md={4}>
            <p className='thinkscompSubHeader'>House rules</p>
            <div className='detailsThingFlexDiv'>
                <FaFilter/>
                <span>Check-in: After 3:00 PM</span>
            </div>
        </Grid>
        <Grid item md={4}>
        <p className='thinkscompSubHeader'>Health & safety</p>
            <div className='detailsThingFlexDiv'>
                <FaFilter/>
                <span>Airbnb's COVID-19 safety practices apply</span>
            </div>
            <div className='detailsThingFlexDiv'>
                <FaFilter/>
                <span>Carbon monoxide smoke</span>
            </div>
            <div className='detailsThingFlexDiv'>
                <FaFilter/>
                <span>Smoke alarm</span>
            </div>
            <p style={{fontWeight:600}}><span className='showMore'>Show more</span>{' >'}</p>

        </Grid>
        <Grid item md={4}>
        <p className='thinkscompSubHeader'>Cancellation policy</p>
        <p className='thinksTxt'>This reservation is non-refundable</p>
        <p className='thinksTxt thinksTxt2'>Review the Host's full cancellation policy whuch applies even if you cancel for illness or 
            disruptions caused by COVID-19.
        </p>
        <p style={{fontWeight:600}}><span className='showMore'>Show more</span>{' >'}</p>

        </Grid>
    </Grid>
    </div>
  )
}

export default DetailsThingComp